import { createAction, props } from '@ngrx/store';
import { WishlistItem } from 'src/app/shared/models';

// Load Guest Wishlist
export const getGuestWishlist = createAction('[Wishlist] Get Guest Wishlist');
export const getGuestWishlistSuccess = createAction(
  '[Wishlist] Get Guest Wishlist Success',
  props<{ items: WishlistItem[] }>()
);
export const getGuestWishlistFailure = createAction(
  '[Wishlist] Get Guest Wishlist Failure',
  props<{ error: any }>()
);

// Add Guest Wishlist Item
export const addGuestWishlistItem = createAction(
  '[Wishlist] Add Guest Wishlist Item',
  props<{ propertyId: number }>()
);
export const addGuestWishlistItemSuccess = createAction(
  '[Wishlist] Add Guest Wishlist Item Success',
  props<{ item: WishlistItem }>()
);
export const addGuestWishlistItemFailure = createAction(
  '[Wishlist] Add Guest Wishlist Item Failure',
  props<{ propertyId: number; error: any }>() // include propertyId
);

// Remove Guest Wishlist Item
export const removeGuestWishlistItem = createAction(
  '[Wishlist] Remove Guest Wishlist Item',
  props<{ propertyId: number }>()
);
export const removeGuestWishlistItemSuccess = createAction(
  '[Wishlist] Remove Guest Wishlist Item Success',
  props<{ propertyId: number }>()
);
export const removeGuestWishlistItemFailure = createAction(
  '[Wishlist] Remove Guest Wishlist Item Failure',
  props<{ propertyId: number; error: any }>() // include propertyId
);
